import React from "react";
import styled from "@emotion/styled";
import { trackEvent } from "@utils/api/tracker";
import Select from "src/components/core/Select";
import i18n from "src/locales";

import { NavBarItem } from "./Styles";
import { getLanguage } from "src/utils/meristemContext";

interface LanguagePickerProps {
  menuOpen?: boolean;
}

const NavBarSelect = styled(NavBarItem)`
  text-transform: uppercase !important;
  cursor: pointer;
  background-color: transparent;
  font-weight: bold;
  font-family: "Brown LL";
  border: none;

  @media all and (max-width: 1100px) {
    border: none;
    text-transform: none !important;
    background-color: transparent;
    text-align: center;
    text-align-last: center;
  }

  option {
    color: currentColor;
  }
`.withComponent(Select);

function LanguagePicker({ menuOpen }: LanguagePickerProps) {
  const language = getLanguage();

  return (
    <NavBarSelect
      menuOpen={menuOpen}
      onClick={() => trackEvent("ClickedNavLanguageDropdown")}
      onChange={(e) => {
        const languageClicked = e.target.value;
        window.location.href = `/${languageClicked}/`;
        trackEvent("ClickedNavLanguageLink", {
          languageClicked,
        });
      }}
      value={language}
      aria-label={i18n.t("navBar:selectLanguage")}
    >
      <option value="en">EN</option>
      <option value="de">DE</option>
      <option value="es">ES</option>
      <option value="ko">KR</option>
    </NavBarSelect>
  );
}

export default LanguagePicker;
